import axios from 'axios'
import { DEFAULT_NETWORK } from './store/modules/network/network'

const INDEXER_URL = DEFAULT_NETWORK.indexerUrl

export default axios.create({
    baseURL: INDEXER_URL,
    withCredentials: false,
    headers: {
        'Content-Type': 'application/json',
    },
})
